import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, SelectField, SelectItem, Button } from "@kuda/ui";
import { config } from "../config";

/**
 * Applies a new Environment and/or Team to every selected secret. Either
 * field can be left unset to leave it untouched across the whole selection —
 * only the fields you actually pick a value for get changed.
 */
const BulkRetagDialog = ({ open, onClose, count, onConfirm }) => {
  const [environment, setEnvironment] = useState("");
  const [team, setTeam] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setEnvironment("");
      setTeam("");
      setError("");
    }
  }, [open]);

  const canSubmit = !!environment || !!team;

  const handleConfirm = async () => {
    if (!canSubmit) return;
    setLoading(true);
    setError("");
    try {
      await onConfirm({ environment, team });
    } catch (err) {
      setError(err.response?.data?.error || err.message || "Failed to update tags.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next && !loading) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit tags for {count} secret{count === 1 ? "" : "s"}</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-4">
          <p className="text-sm text-color-text-secondary">
            Only the fields you set below will change — leave a field blank to keep it as-is on every selected secret.
          </p>

          <SelectField label="Environment" placeholder="Leave unchanged" value={environment} onValueChange={setEnvironment}>
            {config.environments.map((env) => (
              <SelectItem key={env.value} value={env.value}>{env.label}</SelectItem>
            ))}
          </SelectField>

          <SelectField label="Team" placeholder="Leave unchanged" value={team} onValueChange={setTeam}>
            {config.projects.map((proj) => (
              <SelectItem key={proj.value} value={proj.value}>{proj.label}</SelectItem>
            ))}
          </SelectField>

          {error && <p className="text-sm text-color-text-state-error-default">{error}</p>}
        </div>

        <DialogFooter>
          <Button variant="text" onClick={onClose} disabled={loading}>Cancel</Button>
          <Button variant="filled" onClick={handleConfirm} loading={loading} disabled={!canSubmit}>
            Apply
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkRetagDialog;
